import stylesheet from './TabContent.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

class NXTTabContent extends CustomComponent {
    static observedAttributes = ['active'];

    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    get isActive() {
        return this.hasAttribute('active');
    }

    render() {
        const content = document.createElement('div');
        content.classList.add('tab-content')
        content.innerHTML = `
            <slot></slot>
        `;
        return content;
    }

    // noinspection JSUnusedGlobalSymbols
    // @ts-ignore
    attributeChangedCallback(name: string, oldValue: string, newValue: string) {
        console.log(name, oldValue,newValue)
        if (name === 'active') {
            this.updateStyles();
        }
    }

    updateStyles() {
        const tabContent = this.shadowRoot.querySelector('.tab-content');
        if (this.isActive) {
            tabContent.classList.add('active');
        } else {
            tabContent.classList.remove('active');
        }
    }

}

customElements.define('nxt-tab', NXTTabContent);
